import { AutomationClauseType } from '~/enums/AutomationClauseTypes';
import { AutomationStatusType } from '~/enums/AutomationStatusType';

export const CLAUSE_STATUS_ID = 'statusFilter';
export const CLAUSE_TYPE_ID = 'typeFilter';

export const ALL_STATUSES = [
  AutomationStatusType.ACTIVE,
  AutomationStatusType.SUSPENDED,
];
export const ALL_TYPES = [
  AutomationClauseType.QUICK_AI,
  AutomationClauseType.GUIDED_AI,
];

export const filtersOptions = {
  disableManageFilters: true,
  disableRemoveFilter: true,
  disableClearFilters: true,
};
